const CreditCardQualificationMethods: any = {
  COUNT: 'Transaction Count',
  SPEND: 'Total Spend',
  COUNT_AND_SPEND: 'Transaction Count and Total Spend',
  COUNT_OR_SPEND: 'Transaction Count or Total Spend',
};

export default CreditCardQualificationMethods;
